import React from "react";
import classes from "../styles/style.module.css";
import CalendarIcon from "../../../assets/images/Roshana/calendar.svg";
import MobileIcon from "../../../assets/images/Roshana/mobile.svg";

const Banner = ({ icon, title, Description, color }) => {
  return (
    <div
      className={`${
        color === "green" ? classes.greenBanner : classes.orangeBanner
      } ${classes.smallBannerContainer}`}
    >
      <img src={icon} alt="small banner img" />
      <div className={classes.smallBannerTitle}>{title}</div>
      <p className={classes.smallBannerDesc}>{Description}</p>
    </div>
  );
};

const DoubleBanners = () => {
  return (
    <div className={"customContainer"}>
      <div className={classes.doubleBannersConatiner}>
        <Banner
          icon={CalendarIcon}
          color={"green"}
          title={"زمان برگزاری"}
          Description={"در کانال های اطلاع رسانی"}
        />
        <Banner
          icon={MobileIcon}
          color={"orange"}
          title={"بستر برگزاری"}
          Description={"مجازی در پیامرسان ایتا یا تلگرام"}
        />
      </div>
    </div>
  );
};

export default DoubleBanners;
